import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ChangePasswordCard() {
  const { user } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  if (user?.impersonated_by) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) { toast.error("La nuova password deve avere almeno 8 caratteri"); return; }
    if (f.next !== f.confirm) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try { await api.put("/me/password", { current_password: f.current, new_password: f.next }); toast.success("Password aggiornata"); setF({ current: "", next: "", confirm: "" }); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="bg-white rounded-2xl border border-stone-200 p-6 space-y-3 mt-6" data-testid="account-change-password">
      <h2 className="text-base md:text-lg font-semibold text-[#0B2A45] flex items-center gap-2"><KeyRound className="w-4 h-4 text-[#C2593F]" />Cambia password</h2>
      <div><Label>Password attuale</Label><Input type="password" autoComplete="current-password" value={f.current} onChange={set("current")} required data-testid="change-pwd-current" /></div>
      <div><Label>Nuova password</Label><Input type="password" autoComplete="new-password" value={f.next} onChange={set("next")} minLength={8} required data-testid="change-pwd-new" /></div>
      <div><Label>Conferma nuova password</Label><Input type="password" autoComplete="new-password" value={f.confirm} onChange={set("confirm")} required data-testid="change-pwd-confirm" /></div>
      <Button type="submit" disabled={busy} variant="outline" className="w-full h-11 rounded-full border-[#0F4C81] text-[#0F4C81]" data-testid="change-pwd-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Aggiorna password"}</Button>
    </form>
  );
}
